import React, { useEffect, useState } from 'react'
import { userService } from '../../../services/user.service'
import { useParams, Link } from 'react-router-dom'
import { StatsTotal } from '../../../components/Dashboard/StatsTotal'

export const AccountStatsTotal = () => {
  const { idEventoTotal } = useParams()
  console.log(idEventoTotal)
  const [publications, setPublications] = useState([])
  useEffect(() => {
    const getAllReservations = async () => {
      try {
        const reservaciones = await userService.getAllStatsEvent(idEventoTotal)
        setPublications(reservaciones)
      } catch (error) {
        console.log(error)
      }
    }
    getAllReservations()
  }, [])
  return (
    <>
      {/* Account collections */}
      <div className="pb-5 mb-lg-2 mt-md-0">
        <div className="ps-md-3 ps-lg-0 mt-md-2 pt-md-4 pb-md-2">
          {
            publications.map((pub, index) => (<StatsTotal key={index}{...pub}/>))
          }
        </div>
      </div>

    </>
  )
}
